import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const slice = createSlice({
  name: 'event',
  initialState: reHydrateStore('event') || null,
  reducers: {
    setEvent: (state, { payload }) => ({
      ...payload,
      has_reservation_survey: payload?.has_reservation_survey ?? false,
      has_ticket_survey: payload?.has_ticket_survey ?? false,
    }),
  },
});

export const { setEvent } = slice.actions;

export default slice.reducer;

export const selectCurrentEvent = (state) => state.event;